import { render, staticRenderFns } from "./isExclusiveBlock.vue?vue&type=template&id=6e6b31fc&lang=pug&"
import script from "./isExclusiveBlock.vue?vue&type=script&lang=ts&"
export * from "./isExclusiveBlock.vue?vue&type=script&lang=ts&"
import style0 from "./isExclusiveBlock.vue?vue&type=style&index=0&id=6e6b31fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports